import { render } from "./PagarView.vue?vue&type=template&id=689c88d6&scoped=true"
import script from "./PagarView.vue?vue&type=script&lang=js"
export * from "./PagarView.vue?vue&type=script&lang=js"

import "./PagarView.vue?vue&type=style&index=0&id=689c88d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689c88d6"]])

export default __exports__